const readFlag = (value: string | undefined, fallback: boolean) =>
  value === undefined ? fallback : value.toLowerCase() === 'true';

export const LOGIN_ENABLED = readFlag(process.env.REACT_APP_LOGIN_ENABLED, true);
export const MOCK_FALLBACK_ENABLED = readFlag(
  process.env.REACT_APP_MOCK_FALLBACK_ENABLED,
  true,
);
